import React from 'react';

import { Typography } from '@mui/material';

import { DateFormatter, NumberFormatter } from '@waypoint/react/formatters';

type Props = {
  children?: string | number;
};

export default function SimpleTextCell({ children }: Props) {
  if (!children) {
    return <Typography color="text.secondary">--</Typography>;
  }
  return <Typography color="text.primary">{children}</Typography>;
}

type SimpleDateCellProps = {
  value: Date | null;
};
export function SimpleDateCell({ value }: SimpleDateCellProps) {
  if (value === null) {
    return <Typography color="text.secondary">--</Typography>;
  }
  return (
    <Typography color="text.primary">
      <DateFormatter value={value} />
    </Typography>
  );
}

type SimpleNumberCellProps = {
  value: number | null;
};
export function SimpleNumberCell({ value }: SimpleNumberCellProps) {
  if (value === null) {
    return <Typography color="text.secondary">--</Typography>;
  }
  return (
    <Typography color="text.primary">
      <NumberFormatter value={value} />
    </Typography>
  );
}
